// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-alert {
  /* Typography */
  --perxis-auto-alert-font-size-inner: var(--perxis-auto-alert-font-size, var(--perxis-auto-root-typography-main-font-size-xxl-inner));
  --perxis-auto-alert-icon-font-size-inner: var(--perxis-auto-alert-icon-font-size, var(--perxis-auto-root-typography-h4-font-size-xxl-inner));
  --perxis-auto-alert-success-color-inner: var(--perxis-auto-alert-success-color, var(--perxis-auto-root-typography-color-lightest-inner));
  --perxis-auto-alert-info-color-inner: var(--perxis-auto-alert-info-color, var(--perxis-auto-root-typography-color-lightest-inner));
  --perxis-auto-alert-error-color-inner: var(--perxis-auto-alert-error-color, var(--perxis-auto-root-typography-color-lightest-inner));
  --perxis-auto-alert-warning-color-inner: var(--perxis-auto-alert-warning-color, var(--perxis-auto-root-typography-color-lightest-inner));
  /* End typography */
  /* Colors */
  --perxis-auto-alert-success-background-color-inner: var(--perxis-auto-alert-success-background-color, var(--perxis-auto-root-twelve-color-inner));
  --perxis-auto-alert-success-border-color-inner: var(--perxis-auto-alert-success-border-color, var(--perxis-auto-root-twelve-color-inner));
  --perxis-auto-alert-info-background-color-inner: var(--perxis-auto-alert-info-background-color, var(--perxis-auto-root-twelve-color-inner));
  --perxis-auto-alert-info-border-color-inner: var(--perxis-auto-alert-info-border-color, var(--perxis-auto-root-twelve-color-inner));
  --perxis-auto-alert-error-background-color-inner: var(--perxis-auto-alert-error-background-color, var(--perxis-auto-root-third-color-inner));
  --perxis-auto-alert-error-border-color-inner: var(--perxis-auto-alert-error-border-color, var(--perxis-auto-root-third-color-inner));
  --perxis-auto-alert-warning-background-color-inner: var(--perxis-auto-alert-warning-background-color, var(--perxis-auto-root-third-color-inner));
  --perxis-auto-alert-warning-border-color-inner: var(--perxis-auto-alert-warning-border-color, var(--perxis-auto-root-third-color-inner));
  /* End Colors */
  /* Border */
  --perxis-auto-alert-border-radius-inner: var(--perxis-auto-alert-border-radius, 16px);
  --perxis-auto-alert-border-width-inner: var(--perxis-auto-alert-border-width, 2px);
  /* End Border */
  /* Box Shadow */
  --perxis-auto-alert-box-shadow-inner: var(--perxis-auto-alert-box-shadow, 0px 0px 20px rgba(22, 22, 22, 0.2));
  /* End Box Shadow */
  /* Padding */
  --perxis-auto-alert-padding-inner: var(--perxis-auto-alert-padding, 18px 24px);
  /* End Padding */
  --perxis-auto-typography-color-darkest: var(--perxis-auto-alert-color-inner);
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_18_1-alert[ant-5_24_1-click-animating-without-extra-node=true]::after,
.perxis-auto-1_18_1-alert > *[ant-5_24_1-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_18_1-alert .ant-5_24_1-wave {
  transition: none !important;
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: var(--perxis-auto-alert-padding-inner);
  border-width: var(--perxis-auto-alert-border-width-inner);
  border-style: solid;
  border-radius: var(--perxis-auto-alert-border-radius-inner);
  box-shadow: var(--perxis-auto-alert-box-shadow-inner);
  user-select: none;
  cursor: pointer;
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-alert-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-alert-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-alert-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-alert-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-alert-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-alert-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-alert-font-size-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert .ant-5_24_1-alert-close-icon {
  margin-inline-start: 12px;
  font-size: var(--perxis-auto-alert-icon-font-size-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-alert-icon-font-size-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-success {
  border-color: var(--perxis-auto-alert-success-border-color-inner);
  background-color: var(--perxis-auto-alert-success-background-color-inner);
  --perxis-auto-typography-color-lightest: var(--perxis-auto-alert-success-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-success .ant-5_24_1-alert-close-icon {
  color: var(--perxis-auto-alert-success-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-success .ant-5_24_1-alert-close-icon svg {
  fill: var(--perxis-auto-alert-success-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-error {
  border-color: var(--perxis-auto-alert-error-border-color-inner);
  background-color: var(--perxis-auto-alert-error-background-color-inner);
  --perxis-auto-typography-color-lightest: var(--perxis-auto-alert-error-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-error .ant-5_24_1-alert-close-icon {
  color: var(--perxis-auto-alert-error-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-error .ant-5_24_1-alert-close-icon svg {
  fill: var(--perxis-auto-alert-error-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-warning {
  border-color: var(--perxis-auto-alert-warning-border-color-inner);
  background-color: var(--perxis-auto-alert-warning-background-color-inner);
  --perxis-auto-typography-color-lightest: var(--perxis-auto-alert-warning-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-warning .ant-5_24_1-alert-close-icon {
  color: var(--perxis-auto-alert-warning-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-warning .ant-5_24_1-alert-close-icon svg {
  fill: var(--perxis-auto-alert-warning-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-info {
  border-color: var(--perxis-auto-alert-info-border-color-inner);
  background-color: var(--perxis-auto-alert-info-background-color-inner);
  --perxis-auto-root-typography-color-lightest: var(--perxis-auto-alert-info-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-info .ant-5_24_1-alert-close-icon {
  color: var(--perxis-auto-alert-info-color-inner);
}
.perxis-auto-1_18_1-alert.ant-5_24_1-alert-info .ant-5_24_1-alert-close-icon svg {
  fill: var(--perxis-auto-alert-info-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
